import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {useEffect, useState} from "react";
import {SettingService} from "./Service";
import {toast} from "react-hot-toast";
import $ from "jquery";
import XConstants from "../../core/config/Constants";
const RateTypeSetting = () => {
    const [service] = useState(new SettingService());
    const [show, setShow] = useState(false);
    const [rateType, setRateType] = useState('');
    const [id, setId] = useState(0);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const result = await service.addRateType(rateType);
        if (result) {
            setShow(false);
            setRateType('');
            toast.success('Rate type added successfully');
            getItems();
        }
    }

    const handleUpdate = async (e: any) => {
        e.preventDefault();
        const result = await service.updateRateType({
            id: id,
            type: rateType
        });
        if (result) {
            setShow(false);
            setRateType('');
            setId(0);
            toast.success('Rate type updated successfully');
            getItems();
        }
    }

    const getItems = () => {
        try {
            $('#items').DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem('token');
        $('#items').DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {

                    "render": function (data: string, type: any, row: any) {
                        if (data === 'Active') {
                            return `<p class="badge bg-success p-2 rounded-3">Active</p>`;
                        } else {
                            return `<p class="badge bg-danger p-2 rounded-3">Inactive</p>`;
                        }
                    },
                    "targets": 2
                },
                {

                    "render": function (data: any, type: any, row: string[]) {
                        if (row[2] === 'Active') {
                            return `<button class="btn btn-danger">Deactivate</button>`;
                        } else {
                            return `<button class="btn btn-success">Activate</button>`;
                        }
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            const status = rowData[2] === 'Active' ? 'Inactive' : 'Active'
                            const res = await service.updateRateType({
                                id: rowData[4],
                                status: status
                            });
                            if (res) {
                                toast.success("Rate type updated successfully", {});
                                getItems();
                            }
                        })
                    },
                    "targets": 4
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-primary">Details</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click((e: any) => {
                            setId(rowData[5]);
                            setRateType(rowData[1]);
                            setShow(true);
                        })
                    },
                    "targets": 5
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-danger">Delete</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            const res = await service.updateRateType({
                                id: rowData[6],
                                deleted: true
                            });
                            if (res) {
                                toast.success("Rate type deleted successfully", {});
                                getItems();
                            }
                        })
                    },
                    "targets": 6
                },
            ],
            ajax: {
                url: `${XConstants.baseUrl}/company/setting/rate-type/list`,
                type: 'POST',
                contentType: 'application/json',
                headers: {
                    'Authorization': token,
                },
                data: function(d: any) {
                    return JSON.stringify({
                        ...d,
                    });
                },
            },
        });
    };

    useEffect(() => {
        getItems();
    }, []);

    return (
        <>
            <div className="card">
                <div className="card-body w-100">
                    <div className="content-page-header p-0">
                        <h5>Rate Types</h5>
                        <div className="list-btn">
                            <a
                                href="javascript:void(0);"
                                className="btn btn-primary"
                                onClick={() => {
                                    setShow(true);
                                }}
                            >
                                <i className="fa fa-plus-circle me-2" aria-hidden="true"/>
                                Rate Types
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card-table">
                                <div className="card-body">
                                    <div className="table-responsive no-pagination">
                                        <table className="table table-center table-hover datatable" id="items">
                                            <thead className="thead-light">
                                            <tr>
                                                <th>Id</th>
                                                <th>Type</th>
                                                <th>Status</th>
                                                <th>Added Date</th>
                                                <th>Change Status</th>
                                                <th>Details</th>
                                                <th>Delete</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal fade ${show ? 'show' : ''}`}
                style={{display: 'block', position: 'initial'}}
            >
                <Modal.Dialog>
                    <form onSubmit={id === 0 ? handleSubmit : handleUpdate} className="modal-content border-0">
                        <div className="modal-header border-0 pb-0">
                            <div className="form-header modal-header-title text-start mb-0">
                                <h4 className="mb-0">{id === 0 ? 'Add' : 'Update'} Rate Type</h4>
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    setRateType('');
                                    setShow(false);
                                }}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12 col-md-12">
                                    <div className="input-block mb-3">
                                        <label>Rate Type</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter rate type"
                                            value={rateType}
                                            onChange={(e) => {
                                                setRateType(e.target.value);
                                            }}
                                            required={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer add-tax-btns">
                            <a href="javascript:void(0);" data-bs-dismiss="modal" className="btn add-btn-cancel-btn" onClick={() => {
                                setRateType('');
                                setShow(false);
                            }}>
                                Cancel
                            </a>
                            <button
                                type="submit"
                                className="btn btn-primary add-tax-save-btn"
                                onClick={(e) => {
                                    setShow(false);
                                }}
                            >
                                Save
                            </button>
                        </div>
                    </form>

                </Modal.Dialog>
            </div>
        </>

    );
}

export default RateTypeSetting;
